import {
  AxiosError,
  type AxiosInstance,
  type AxiosRequestHeaders,
} from 'axios';
import type { TAxiosResponseInterceptorError } from './types';
import { memoizedRefreshToken } from './refreshToken';
import { clearCookies } from '../cookies';
import { t } from 'i18next';
import { showNetworkErrorNotification } from '@shared/utils';

export const defaultHeaders: Partial<AxiosRequestHeaders> = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Accept-Language': 'fr',
};

export const errorLogger: TAxiosResponseInterceptorError = error =>
  console.error(error);

export const getHandleAxiosError =
  (axiosInstance: AxiosInstance): TAxiosResponseInterceptorError =>
  async (error: AxiosError) => {
    const errorCode = error.code;
    const isNetworkError = errorCode === 'ERR_NETWORK';

    if (isNetworkError) {
      if (!error.config?.handleNetworkErrorLocally) {
        error.message = t('connectionError');
        showNetworkErrorNotification();
      }

      return Promise.reject(error);
    }

    const config = error.config;

    if (error.response?.status === 401 && config && !config.sent) {
      config.sent = true;

      await memoizedRefreshToken();

      return axiosInstance(config);
    }

    if (error?.response?.status === 401 && config?.sent) {
      clearCookies();

      window.location.href = '/auth';
    }

    return Promise.reject(error);
  };
